import axios from 'axios'
import _ from 'lodash'
import 'core-js/es6/promise'
import forge from 'node-forge'

const mhttp = axios.create({
  baseURL: '/',
  timeout: 100000,
});
mhttp.defaults.headers = Object.assign({}, mhttp.defaults.headers);
mhttp.defaults.headers.common = Object.assign({}, mhttp.defaults.headers.common);

mhttp.interceptors.response.use((ressponse) => ressponse.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['mhttp'] = mhttp; }
if(location.hostname == 'localhost') { window['axios'] = axios; }

// console.log('mhttp', mhttp.defaults)

// 관리자(대상서버) 인증 토큰 발행.
const generateToken = (uuid) => {
  const timestamp = new Date().getTime() + (60 * 5 * 1000); // 5min
  let hmac = forge.hmac.create();
  hmac.start('sha256', uuid);
  hmac.update(`${timestamp}`);
  const sign = forge.util.encode64(hmac.digest().data);
  return `${sign}|${timestamp}`;
}

const ModuleApi = {
  mod: undefined,
  close() { ProxyModuleApi.close(); },
  async setServer(info) {
    let m = info.body ? info.body : info;
    (ModuleApi.mod = (_.startsWith(m.url, 'http:') && location.protocol == 'https:') ? ProxyModuleApi : LegacyModuleApi).setServer(m);
  },

  restart() { return ModuleApi.mod.restart(); },
  status() { return ModuleApi.mod.status(); },
  admin: {
    get() { return ModuleApi.mod.admin.get(); },
    put(data) { return ModuleApi.mod.admin.put(data); },
  },
  setup: {
    get() { return ModuleApi.mod.setup.get(); },
    put(data) { return ModuleApi.mod.setup.put(data); },
  },
  rule: {
    get(name) { return ModuleApi.mod.rule.get(name); },
    put(name, data) { return ModuleApi.mod.rule.put(name, data); },
  },
  user: {
    get() { return ModuleApi.mod.user.get(); },
    put(data) { return ModuleApi.mod.user.put(data); },
  }
};


const LegacyModuleApi = {
  setServer(m) {
    mhttp.defaults.baseURL = m.url;
    mhttp.defaults.headers.common['Authorization'] = m.token;
  },

  restart() { return mhttp.get('/restart'); },
  status() { return mhttp.get('/status'); },
  admin: {
    get() { return mhttp.get(`/admin`); },
    put(data) { return mhttp.put(`/admin`, data); },
  },
  setup: {
    get() { return mhttp.get(`/setup`); },
    put(data) { return mhttp.put(`/setup`, data); },
  },
  rule: {
    get(name) { return mhttp.get(`/rule/${name}`); },
    put(name, data) { return mhttp.put(`/rule/${name}`, data); },
  },
  user: {
    get() { return mhttp.get(`/user`); },
    put(data) { return mhttp.put(`/user`, data); },
  }
};


// WebMessage 구현으로, https - http 이슈 우회함.
const ProxyModuleApi = {
  proxy : {
    ts : [],
    nw : undefined
  },
  receiveMessage(m) {
    var pl = m.data;
    var id = parseInt(pl.id);
    var rr = ProxyModuleApi.proxy.ts[id];
    if(!rr) { return; }
    delete ProxyModuleApi.proxy.ts[pl.id];
    if(pl.error) { rr.reject(pl.reason); }
    else { rr.resolve(pl.body); }
  },
  _open_nw() {
    if(!ProxyModuleApi.proxy.nw || ProxyModuleApi.proxy.nw.closed) {
      ProxyModuleApi.proxy.nw = window.open(`http://${location.host}/proxy/proxy.html?ts=${new Date().getTime()}`, null, `width=466,height=134,left=0,top=${screen.height - 134 - 70}`);
      window['nw'] = ProxyModuleApi.proxy.nw;
      window.addEventListener("message", ProxyModuleApi.receiveMessage, false);
    }
  },
  async setServer(m) {
    ProxyModuleApi._open_nw();
    ProxyModuleApi.proxy.baseURL = m.url;
    ProxyModuleApi.proxy.token = m.token;
  },
  close() {
    if(ProxyModuleApi.proxy.nw && !ProxyModuleApi.proxy.nw.closed) { ProxyModuleApi.proxy.nw.close(); }
  },
  _rpc(target, method, data) {
    ProxyModuleApi._open_nw();
    var pl = { token: ProxyModuleApi.proxy.token, method : method, url : `${ProxyModuleApi.proxy.baseURL}/${target}`, id : new Date().getTime(), body: data };
    if(data) { pl.body = data; }
    return new Promise((resolve, reject) => {
      ProxyModuleApi.proxy.ts[pl.id] = { resolve, reject };
      setTimeout(() => {
        var rr = ProxyModuleApi.proxy.ts[pl.id];
        if(rr) { delete ProxyModuleApi.proxy.ts[pl.id]; rr.reject('timeout'); }
      }, 30000);
      ProxyModuleApi.proxy.nw.postMessage(pl, '*');
    });
  },
  restart() { return ProxyModuleApi._rpc('restart', 'get'); },
  status() { return ProxyModuleApi._rpc('status', 'get'); },
  admin: {
    get() { return ProxyModuleApi._rpc('admin', 'get'); },
    put(data) { return ProxyModuleApi._rpc('admin', 'put', data); }
  },
  setup: {
    get() { return ProxyModuleApi._rpc('setup', 'get'); },
    put(data) { return ProxyModuleApi._rpc('setup', 'put', data); }
  },
  rule: {
    get() { return ProxyModuleApi._rpc('rule', 'get'); },
    put(data) { return ProxyModuleApi._rpc('rule', 'put', data); }
  },
  user: {
    get() { return ProxyModuleApi._rpc('user', 'get'); },
    put(data) { return ProxyModuleApi._rpc('user', 'put', data); }
  }
};


export default ModuleApi;
